import React, { useState } from "react";
import styled from "@emotion/styled";
import InputEmail from "../../../../shared/InputTextEmail";
import CheckBox from "../../../../shared/CheckBox";
import "./EmailComponent.css";

const TextComponent = ({ config, question, actions, activate, focus }) => {
    const Wrapper = {
        width: "100%",
    };

    const Title = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        backgroundColor: "#3C3C3B",
        color: "white",
        fontSize: "3.5vh",
        padding: "2vh",
        textAlign: "center",
        fontWeight: "bold",
    }

    const Subtitle = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        color: "#3C3C3B",
        fontSize: "3.5vh",
        padding: "1vh",
        textAlign: "center",
        fontWeight: "bold",
    }

    const TypeTitle = {
        width: "calc(100% - 4vh)",
        borderRadius: "1vh",
        border: "none",
        color: "#3C3C3B",
        backgroundColor: "transparent",
        fontSize: "2.5vh",
        padding: "1vh",
        textAlign: "left",
        fontWeight: "bold",
    }

    const Label = styled.label`
        ${props => `
            width: "calc(100% - 4vh)",
            borderRadius: "1vh",
            color: "#3C3C3B",
            fontSize: "2.5vh",
            padding: "2vh",
            textAlign: "left",
            fontWeight: "bold",
        `};
    `;

    const OptionsWrapper = {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        margin: "1vh 0",
        padding: "3vh 0",
        overflow: "hidden",
        columnGap: "2vh",
        rowGap: "2vh"
    };

    const CheckBoxWrapper = {
        width: "100%",
        display: "flex",
        flexWrap: "wrap",
        margin: "1vh 0",
        padding: "1vh 0",
        overflow: "hidden",
        columnGap: "2vh",
        rowGap: "2vh",
        flexDirection: "column"
    };

    const WrapperBottom = {
        width: "100%",
        display: "flex",
        margin: "1vh 0",
        padding: "1vh 0",
        overflow: "hidden",
    };

    const Button = styled.button`
        width: 100%;
        border-radius: 1vh;
        border: none;
        background-color: ${activate ? "#00963f" : "#3C3C3B"};
        color: white;
        font-size: 3.5vh;
        padding: 2vh;
        text-align: center;
        font-weight: bold;
        pointer-events: auto; 
        cursor: pointer;

        ${activate ? "animation-name: activate; animation-iteration-count: infinite; animation-duration: 0.6s; animation-timing-function: linear; animation-direction: alternate; @keyframes activate {from { transform: scale(1.0); } to { transform: scale(0.95); }}" : ""}
    `;

    const Input = styled.input`
        ${props => `
            flex: 1 1 calc(${props.multipleRow ? "50%" : "100%"} - 5vh);
            border-radius: 1vh;
            font-size: 2.5vh;
            text-align: center;
            padding: 1.5vh;
            font-weight: bold;
            max-height: 20vh;

            cursor: pointer;
            animation-timing-function: linear;
            animation-fill-mode: forwards;
            animation-duration: 0.4s;
            animation-iteration-count: 4;
            animation-delay: 0s;

            @keyframes select {
                0% { transform: rotate(0deg); }
                25% { transform: rotate(3deg); }
                50% { transform: rotate(0deg); }
                75% { transform: rotate(-3deg); }
                100% { transform:  rotate(0deg); }
            }
        `};
    `;

    const DivCheck1 = {
        fontWeight: "bold",
        color: "#3C3C3B",
        fontSize: "2.5vh",
        cursor: "pointer",
        textDecoration: "underline",
    }

    const DivCheck2 = {
        fontWeight: "bold",
        color: "#3C3C3B",
        fontSize: "2.5vh",
    }

    const WrapperCheckbox = {
        display: "flex",
        alignItems: "center",
    }

    return (
        <div style={Wrapper}>
            <div style={Title}>
                {config.getTranslatedText(question?.questionTitle)}
            </div>
            <div style={OptionsWrapper}>
                <div style={Subtitle}>
                    {config.getTranslatedText(question?.questionSubtitle)}
                </div>
                <div style={TypeTitle}>{config.strings.mailName}</div>
                <InputEmail
                    placeholder={config.strings.mailNameHold}
                    onChange={e => { actions.addFreeTextResponse("name", e.target.value) }}
                    defaultValue={question?.freeResponse?.name} />
                <div style={TypeTitle}>{config.strings.mailCorreo}</div>
                <InputEmail
                    placeholder={config.strings.mailCorreoHold}
                    onChange={e => { actions.addFreeTextResponse("email", e.target.value) }}
                    defaultValue={question?.freeResponse?.email}
                    type={"email"}
                    config={config} />
                <div class="divCheckbox" style={WrapperBottom}>
                    <div style={CheckBoxWrapper}>
                        <div style={WrapperCheckbox}>
                            <CheckBox type={"checkbox"}
                                onChange={e => { actions.addFreeTextResponse("checkedLOPD", e.target.checked) }}
                                defaultChecked={question?.freeResponse?.checkedLOPD} />
                            <div style={DivCheck1} onClick={actions.openRGPD}>{config.strings.mailLOPD}</div>
                        </div>
                        {question?.newsletterEnabled ? (
                            <div style={WrapperCheckbox}>
                                <CheckBox type={"checkbox"}
                                    onChange={e => { actions.addFreeTextResponse("checkedNewsletter", e.target.checked) }}
                                    defaultChecked={question?.freeResponse?.checkedNewsletter} />
                                <div style={DivCheck2}>{config.strings.mailNewsletter}</div>
                            </div>
                        ) : (null)}
                    </div>
                    <div style={CheckBoxWrapper}>
                        <Button onClick={actions.acceptButton}>{config.strings.acceptButton}</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TextComponent;